import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Spine } from "pixi-spine";
import { resetSpine } from "utils/Misc";

export class MultiplierBadge extends View {
    spine: Spine;

    constructor(services: GameServices) {
        super(services);

        const {factory, resources} = this.services;

        this.spine = factory.createSpine(resources.getSpec(`multiplierbadge`), this);
        this.visible = false;
    }

    setValue(value: number) {
        this.spine.skeleton.setSkinByName(`x${value}`);
        this.spine.skeleton.setToSetupPose();
    }

    playLandAnim(): void {
        this.spine.state.setAnimation(0, `intro`, false);
    }

    startWinAnimLoop(): void {
        this.spine.state.setAnimation(0, `win`, true);
    }

    stopWinAnimLoop(): void {
        resetSpine(this.spine);
    }

    override reset(): void {

        resetSpine(this.spine);

        this.visible = false;
        this.spine.visible = true;
    }
}